import { ReactElement } from "react";
import type { IconProps } from "./iconPropsTypes";

const XLogoIcon = ({ fill = "black", style }: IconProps): ReactElement => (
  <svg
    fill="none"
    height="62"
    role="graphics-document"
    style={style}
    viewBox="0 0 60 62"
    width="60"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Twitter</title>
    <g
      clipPath="url(#clip0_570_1698)"
      transform="matrix(0.49656547,0,0,0.49656547,15.103037,15.979937)"
    >
      <path
        className="x-logo-svg-path"
        d="M 35.7082,26.0277 58.0445,0 h -5.293 L 33.3569,22.5995 17.8664,0 H 0 L 23.4246,34.1744 0,61.4684 H 5.2933 L 25.7746,37.6026 42.1336,61.4684 H 60 L 35.7069,26.0277 Z m -7.25,8.4478 -2.3733,-3.403 L 7.20055,3.99446 h 8.13015 l 15.2399,21.85284 2.3734,3.403 19.81,28.4053 H 44.6238 L 28.4582,34.4768 Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_570_1698">
        <rect fill="#ffffff" height="61.5" width="60" x="0" y="0" />
      </clipPath>
    </defs>
  </svg>
);

export default XLogoIcon;
